/** @jsxImportSource @emotion/react */
import React, { Fragment, useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { CreateSide, ManageTable } from '../../../components/templates'
import { get_staff_cards } from '../../../redux/actions/staff_cards/get_staff_cards'
import * as styles from '../index.styles'
import { columns } from './mockData'

const ManageStaffTeam: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()

  const token = localStorage.getItem('token')
  const data = useSelector((state: any) => state.get_staff_cards.data)

  useEffect(() => {
    dispatch(get_staff_cards({ lang: null, token }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (location.pathname === '/app/content-management/manage-staff-team') {
      setTimeout(() => {
        dispatch(get_staff_cards({ lang: null, token }))
      }, 1500)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  return (
    <Fragment>
      <div css={styles.root}>
        <div css={styles.main}>
          <ManageTable
            title="Administrar - Integrantes del equipo"
            subtitle="Integrantes del equipo - publicados"
            columns={columns}
            data={data ? data?.data : []}
            route="/app/content-management/create-staff-team/"
          />
        </div>

        <div css={styles.right}>
          <CreateSide
            title="Crear nuevo - Integrante del equipo"
            message=""
            textButton="Crear nuevo"
            onCreate={() =>
              navigate('/app/content-management/create-staff-team')
            }
          />
        </div>
      </div>
    </Fragment>
  )
}

export default ManageStaffTeam
